import {
  ref,
  Ref,
} from 'vue';

interface Dialog {
  isVisible: Ref<boolean>;
  toggle: () => void;
}

// TODO выпилить, достаточно рефа
export function useDialog(): Dialog {
  const isVisible = ref<boolean>(false);
  const toggle = () => {
    isVisible.value = !isVisible.value;
  };

  return {
    isVisible,
    toggle,
  };
}
